import React from "react";
var ConditionalWrap = function (_a) {
    var condition = _a.condition, wrap = _a.wrap, children = _a.children;
    return (condition ? React.cloneElement(wrap(children)) : children);
};
export { ConditionalWrap };
